import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import $ from "jquery";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "./UserActivityLog.scss";
import axios from "axios";
import accessToken from "../../../helpers/jwt-token-access/accessToken";

import toastr from "toastr";

import UndoIcon from '@mui/icons-material/Undo';

import {
  getDate,
  getFirstday,
  getLocalbody
} from "../../../helpers/globalFunctions";
import Select from "react-select";
import moment from "moment";
import { Tooltip } from "@mui/material";
const DatatableTables = () => {
  const [searchData, setSearchData] = useState({
    from_date: getFirstday(new Date()),
    to_date: getDate(new Date()),
  });
  const [details, setDetails] = useState([]);
  const [currentLocalbody, setCurrectLocalbody] = useState(getLocalbody());
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
  /** pagination */
  const [searchValue, setSearchValue] = useState("");
  // const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [PerPageCount, setPerPageCount] = useState(20);
  const [indexOfLastTransfer, setindexOfLastTransfer] = useState(
    currentPage * PerPageCount
  );

  const [indexOfFirstTransfer, setindexOfFirstTransfer] = useState(
    indexOfLastTransfer - PerPageCount
  );
  // const paginate = (event, value) => {
  //   setCurrentPage(value);
  //   const indexOfLastTransfer = value * PerPageCount;
  //   const indexOfFirstTransfer = indexOfLastTransfer - PerPageCount;
  //   setindexOfFirstTransfer(indexOfFirstTransfer);
  //   setindexOfLastTransfer(indexOfLastTransfer);
  //   handleTableData(searchValue, searchData?.from_date, searchData?.to_date, selectedStaff?.value, indexOfFirstTransfer, indexOfLastTransfer);
  // };
  const resetPaginate = () => {
    setCurrentPage(1);
    const indexOfLastTransfer = 20;
    const indexOfFirstTransfer = 0;
    setindexOfFirstTransfer(indexOfFirstTransfer);
    setindexOfLastTransfer(indexOfLastTransfer);
  }
  const handleSearch = (value) => {
    setSearchValue(value)
    resetPaginate();
    handleTableData(value, searchData?.from_date, searchData?.to_date, selectedStaff?.value);

  }
  useEffect(() => {
    handleTableData(searchValue);
    fetch_all_staff(currentLocalbody);
  }, [currentLocalbody]);
  /** end pagination */



  const handleTableData = (search = "", from_date = "", to_date = "", staff_id = "") => {
    let userid = "";
    if (localStorage.getItem("authUser")) {
      var data = localStorage.getItem("authUser");
      var user_obj = JSON.parse(data);
      userid = user_obj._id;
    }
    var url =
      `${API_URL}security/userlog?user_id=` + userid;

    if (from_date === "" && to_date === "") {
      from_date = from_date ? from_date : getFirstday(new Date());
      to_date = to_date ? to_date : getDate(new Date());
    }
    url =
      url +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&staff_id=" +
      staff_id + "&search=" + search;
    axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        result &&
          result.map((item, index) => {

            item.id = index + 1;

            item.time = moment(item.time, "HHmmss").format("hh:mm a");

            item.activity = (
              <span>{item.activity_desc} {item.type != 0 && <Tooltip><UndoIcon onClick={() => handleIconData(item)} style={{ cursor: "pointer" }} /></Tooltip>}</span>
            )

            return item

          });
        setDetails(result);
      });
  };
  const fetch_all_staff = (id) => {
    axios
      .get(`${API_URL}user/options?localbody_id=` + id, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        var staff_data =
          res.data.data &&
          res.data.data.map((el) => {
            if (el?.lastName) el.name = el.firstName + " " + el.lastName;
            else el.name = el.firstName;
            return {
              label: el.name,
              value: el._id,
            };
          });
        setStaffOptions([
          {
            options: staff_data,
          },
        ]);
      });
  };
  let handleDate = (e) => {
    if (e.target.name == "from_date") {
      var date1 = e.target.value;
      var date2 = searchData?.to_date;
    }
    else {
      var date1 = searchData?.from_date;
      var date2 = e.target.value;
    }

    let staff_id = searchData?.staff_id ? searchData.staff_id : "";
    let toDate = moment(date1);
    let fromDate = moment(date2);
    let result = fromDate.diff(toDate, "days");

    if (result + 1 <= 0) {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
        ["to_date"]: "",
      });
      date2 = "";
    } else {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    handleTableData(searchValue, date1, date2, staff_id);
  };
  const handleSelectChange = (selected) => {
    let date1 = searchData?.from_date ? searchData.from_date : "";
    let date2 = searchData?.to_date ? searchData.to_date : "";
    setSelectedStaff(selected);
    setSearchData({
      ...searchData,
      ["staff_id"]: selected.value,
    });
    resetPaginate();
    handleTableData(searchValue, date1, date2, selected.value);
  };
  const reset = () => {
    setSearchData({
      // from_date: getFirstday(new Date()),
      // to_date: getDate(new Date()),
    });
    setSelectedStaff(null);
    resetPaginate();
    handleTableData(searchValue);
  };
  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Date",
        field: "date",
        sort: "asc",
        width: 270,
      },
      {
        label: "Time",
        field: "time",
        sort: "asc",
        width: 270,
      },

      {
        label: "Created IP",
        field: "activity_ip",
        sort: "asc",
        width: 100,
      },
      {
        label: "Staff",
        field: "activity_user",
        sort: "asc",
        width: 100,
      },
      {
        label: "Activity",
        field: "activity",
        sort: "asc",
        width: 100,
      },
      // {
      //   label: "Action",
      //   field: "action",
      //   sort: "asc",
      //   width: 100,
      // },
    ],
    rows: details,
  };

  function handleIconData(detail) {
    let data = {
      _id: detail?.data_id,
      type: detail?.type,
    }
    axios
      .put(`${API_URL}api/staff/restore`, data, {
        headers: {
          "x-access-token": accessToken,
        },
      }).then((res) => {

        toastr.success("User restored successfully")

        // let result = res.data;

        handleTableData();
      }).catch((err)=>{

        toastr.error("Something went wrong! Please try again")
      })
  }

  
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="User Activity Log" />

          {/*Text field 1*/}
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col md="2">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom05">From</Label>
                          {/* <div className="col-md-10"> */}
                          <input
                            className="form-control"
                            type="date"
                            id="from_date"
                            name="from_date"
                            value={searchData?.from_date}
                            onChange={handleDate}
                          />
                          {/* </div> */}
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom05">To</Label>
                          {/* <div className="col-md-10"> */}
                          <input
                            className="form-control"
                            type="date"
                            id="to_date"
                            name="to_date"
                            value={searchData?.to_date}
                            min={searchData?.from_date}
                            onChange={handleDate}
                          />
                          {/* </div> */}
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label>Staff</Label>
                          <Select
                            name="staff_id"
                            value={selectedStaff}
                            onChange={(selected) => {
                              handleSelectChange(selected);
                            }}
                            options={staffOptions}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="1" style={{ paddingTop: "4px" }}>
                        <div className="mt-4 mb-3">
                          <Button
                            color="danger"
                            type="reset"
                            onClick={() => reset()}
                          >
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    id="useractivitylogId"
                    responsive
                    bordered
                    data={data}
                    searching={true}
                    info={true}
                    disableRetreatAfterSorting={true}
                    onSearch={(value) => { handleSearch(value) }}
                    entries={20}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DatatableTables;
